import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "112",
  height: "112",
  viewBox: "0 0 112 112",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M112 0H0V112H112V0Z",
      fill: "#D7DBF7"
    }, null, -1),
    _createElementVNode("path", {
      d: "M79.3334 18.6667H32.6667C24.9348 18.6667 18.6667 24.9347 18.6667 32.6667V79.3334C18.6667 87.0653 24.9348 93.3334 32.6667 93.3334H79.3334C87.0654 93.3334 93.3334 87.0653 93.3334 79.3334V32.6667C93.3334 24.9347 87.0654 18.6667 79.3334 18.6667Z",
      fill: "#151F6D"
    }, null, -1),
    _createElementVNode("path", {
      d: "M74.6668 35H37.3334C34.7561 35 32.6667 37.0893 32.6667 39.6667V49C32.6667 51.5773 34.7561 53.6667 37.3334 53.6667H74.6668C77.2441 53.6667 79.3334 51.5773 79.3334 49V39.6667C79.3334 37.0893 77.2441 35 74.6668 35Z",
      fill: "#959FEB"
    }, null, -1),
    _createElementVNode("path", {
      d: "M67.6667 63H44.3334C41.7561 63 39.6667 65.0893 39.6667 67.6667V72.3333C39.6667 74.9107 41.7561 77 44.3334 77H67.6667C70.2441 77 72.3334 74.9107 72.3334 72.3333V67.6667C72.3334 65.0893 70.2441 63 67.6667 63Z",
      fill: "#959FEB"
    }, null, -1)
  ])))
}
export default { render: render }